<template>
	<div
		id="dialogs"
	>
		<DefaultDialogView
			v-if="main.show"
			:dialog-model="main"
			@close-dialog="closeDialog"
			@mousedown.stop
			@touchstart.stop
		/>
		<LoaderDialogView
			v-if="loader.show"
			:dialog-model="loader"
			@mousedown.stop
			@touchstart.stop
		/>
		<AuthDialogView
			v-if="auth.show"
			:dialog-model="auth"
			@close-dialog="closeDialog"
			@mousedown.stop
			@touchstart.stop
		/>
		<DefaultDialogView
			v-if="error.show"
			:dialog-model="error"
			@close-dialog="closeDialog"
			@mousedown.stop
			@touchstart.stop
		/>
	</div>
</template>

<style lang="less" scoped>
</style>
